import type { CollaboratorAccrualsRepositoryT } from "../../domain/ports/collaboratorAccruals.repository";

type DeleteCollaboratorAccrualsParamsT = {
  accrualIds: string[];
  colaboraInstanceId: string;
  collaboratorAccrualsRepository: CollaboratorAccrualsRepositoryT;
};

export const deleteCollaboratorAccruals = async ({
  accrualIds,
  colaboraInstanceId,
  collaboratorAccrualsRepository,
}: DeleteCollaboratorAccrualsParamsT) =>
  collaboratorAccrualsRepository.delete(accrualIds, colaboraInstanceId);
